import React, { useState } from "react";
import _ from "lodash";
import { LOGIN, SIGNUP } from "../../../constants/onBoarding";
import { getLocalStorage, setLocalStorage, removeLocalStorage } from "../../../helpers/common";
import { USER_INFO_KEY } from "../../../constants/common";
import { USER_TYPE_MEMBER } from "../../../constants";
import { saveUserType_Title } from "../../../services/v2/signupService";
import { createSubscriptionPlanOnSignup } from "../../../services/PlanService";
import { useCurrentWebsite } from "../../../hooks/useCurrentWebsite";
import { getGitchaAvailableCities } from "../../../services/commonServices";
import { toast } from "react-toastify";
import LoginModal from "./LoginModal";
import SignupModal from "./SignupModal";
import CreateProfileLocationModal from "./CreateProfileLocationModal";

const PENDING_PROFILE_KEY = "pendingCreateProfile";

const AgentOnboardingModalWrapper = (props) => {

  const {
    handleAgentOnboardingModal,
    agentOnboardingPopup,
    handleResetPwdModal,
    handleUserLogin,
    handleMemberProfileModal,
    handleUserTypeModal,
  } = props;

  const { mls } = useCurrentWebsite();

  const isShowPopup = _.get(agentOnboardingPopup, "params.showPopup", false);
  const userAction = _.get(agentOnboardingPopup, "params.userAction", "");

  const isLogin = userAction === LOGIN;
  const isSignup = userAction === SIGNUP;

  const [showCreateProfileLocationModal, setShowCreateProfileLocationModal] = useState(() => {
    return !!getLocalStorage(PENDING_PROFILE_KEY);
  });

  const handleClose = () => {
    handleAgentOnboardingModal?.({ showPopup: false, userAction: null });
  };

  const handleSignupComplete = () => {
    setLocalStorage(PENDING_PROFILE_KEY, true);
    setShowCreateProfileLocationModal(true);
  }

  const finishProfileSetup = async () => {
    try {
      const userInfo = getLocalStorage(USER_INFO_KEY);

      const savedUserTypeAndTitle = await saveUserType_Title({ userTypeId: USER_TYPE_MEMBER });
      if (savedUserTypeAndTitle?.errorCode === 0) {
        userInfo.userInfo.userType = USER_TYPE_MEMBER;
        userInfo.userInfo.agentTitle = null;
        userInfo.userInfo.mls = mls;
      }

      const subscribedUser = await createSubscriptionPlanOnSignup({
        PlanName: "Lite",
        PlanPeriod: 1,
        UserType: 1,
      });

      if (subscribedUser?.errorCode === 0) {
        userInfo.userInfo["planStatus"] = true;
        userInfo.userInfo["planName"] = "Lite";
      }

      setLocalStorage(USER_INFO_KEY, userInfo);
      handleMemberProfileModal({ showModal: true });
    } catch (e) {
      toast.error("Something went wrong while setting up your profile. Please try again later.");
    }
  };

  const handleCreateProfileContinue = async (location) => {
    setShowCreateProfileLocationModal(false);
    removeLocalStorage(PENDING_PROFILE_KEY);

    const userInfo = getLocalStorage(USER_INFO_KEY);
    if (userInfo?.userInfo) {
      userInfo.userInfo.location = location;
      setLocalStorage(USER_INFO_KEY, userInfo);
    }

    try {
      const response = await getGitchaAvailableCities({ state: 'az' });
      const cities = _.get(response, 'result', []);
      const availableMarkets = cities.map((c) => `${c.City}, ${c.State}`);
      if (availableMarkets.includes(location)) {
        handleAgentOnboardingModal?.({ showPopup: false, userAction: null });
        handleUserTypeModal?.({ showModal: true });
      } else {
        finishProfileSetup();
      }
    } catch (e) {
      finishProfileSetup();
    }
  };

  return (
    <>
      <LoginModal
        show={isShowPopup && isLogin}
        onHide={handleClose}
        onLoginSuccess={handleUserLogin}
        handleResetPwdModal={handleResetPwdModal}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
      />

      <SignupModal
        show={isShowPopup && isSignup}
        onHide={handleClose}
        onLoginSuccess={handleUserLogin}
        onSignupComplete={handleSignupComplete}
        agentOnboardingPopup={agentOnboardingPopup}
        handleAgentOnboardingModal={handleAgentOnboardingModal}
        handleMemberProfileModal={handleMemberProfileModal}
        handleUserTypeModal={handleUserTypeModal}
      />

      <CreateProfileLocationModal
        show={showCreateProfileLocationModal}
        onContinue={handleCreateProfileContinue}
      />
    </>
  );
};

export default AgentOnboardingModalWrapper;
